import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { ArtistService, ArtistProfileData } from "../services/ProfileService";
import { TrackData } from "../types/Types";
import { AudioTrack } from "../components/AudioTrack";
import {Toolbar} from "../components/Toolbar";
import "../styles/ArtistProfile.css";

export const ArtistProfile = () => {
  const { userName } = useParams<{ userName: string }>();
  const navigate = useNavigate();

  const [profile, setProfile] = useState<ArtistProfileData | null>(null);
  const [tracks, setTracks] = useState<TrackData[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      if (userName) {
        const data = await ArtistService.fetchArtistData(userName);
        if (data) {
          setProfile(data.profile);
          setTracks(data.tracks);
        }
      }
      setLoading(false);
    };
    loadData();
  }, [userName]);

  if (loading) return <div className="artist-loading">Loading Profile...</div>;
  if (!profile) return <div className="artist-loading">Artist not found.</div>;

  return (
    <div className="artist-page-container">
      <Toolbar />
      <section className="inner-page-layout">
        <section className="inner-page-content">
          <button className="artist-back-btn" onClick={() => navigate(-1)}>
            <ChevronLeft size={20} />
            Back
          </button>

          <div className="artist-header">
            <div className="artist-avatar-container">
              <img
                src={profile.avatarUrl}
                alt={profile.artistName}
                className="artist-avatar"
              />
            </div>

            <div className="artist-info">
              <h1 className="artist-name">{profile.artistName}</h1>
              <h2 className="artist-region">{profile.stateName}</h2>
            </div>
          </div>

          <hr className="artist-divider" />

          <div className="artist-tracks-section">
            <h2 className="artist-section-title">Releases</h2>

            {tracks.length > 0 ? (
              <div className="tracks-container">
                {tracks.map((track) => (
                  <AudioTrack key={track.id} track={track} />
                ))}
              </div>
            ) : (
              <div className="no-tracks-msg">No releases found.</div>
            )}
          </div>
        </section>
      </section>
    </div>
  );
};
